import React, { useState, useEffect } from "react";

import ProductoBuscador from "../buscador/ProductoBuscador.js";
import SelectorCategoria from "../categoria/SelectorCategoria.js";
import ProductoGrid from "../grid/ProductosGrid.js";
import Canasta from "../canasta/CanastaProductos.js";

import { useProductos } from "../../../../contexto/provider/ProductosContext.js";

import TituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloModulo.js";

import "./ProductosLayout.css";

export default function ProductosLayout({ onProductoSeleccionado }) {
  const {
    productosFiltrados,
    cargarProductos,
    filtrarPorNombre,
    filtrarPorCategoria,
  } = useProductos();

  const [productoActivoId, setProductoActivoId] = useState(null);
  const [carrito, setCarrito] = useState([]);
  const [mostrarPopup, setMostrarPopup] = useState(false);

  /* =========================
     CARGA INICIAL DE PRODUCTOS API - SUPABASE
     ========================= */
  useEffect(() => {
    cargarProductos();
  }, [cargarProductos]);

  /* =========================
     INTERACCIONES
     ========================= */
  const toggleProductoActivo = (id) => {
    setProductoActivoId((prev) => {
      const nuevoId = prev === id ? null : id;
      const producto = productosFiltrados.find((p) => p.Codigo === nuevoId);
      console.log("Producto clickeado:", producto);
      onProductoSeleccionado?.(producto || null);
      return nuevoId;
    });
  };
  // Agregar producto al carrito
  const agregarAlCarrito = (producto) => {
    console.log("Producto agregado al carrito:", producto);

    if (!producto?.cantidad) return;

    setCarrito((carritoActual) => {
      const productoExistente = carritoActual.find(
        (item) => item.id === producto.id,
      );
      if (productoExistente) {
        // Si el producto ya está en el carrito, actualizamos su cantidad
        return carritoActual.map((item) =>
          item.id === producto.id
            ? { ...item, cantidad: item.cantidad + producto.cantidad }
            : item,
        );
      } else {
        // Si no existe, lo agregamos como nuevo
        return [...carritoActual, producto];
      }
    });

    // Mostrar popup temporal
    setMostrarPopup(true);
    setTimeout(() => setMostrarPopup(false), 1500);
  };
  // Limpiar carrito
  const limpiarCarrito = () => {
    setCarrito([]);
  };

  /* =========================
     RENDER
  ========================= */
  return (
    <div className="layout-ventas">
      <TituloModulo titulo="Productos Disponibles" />
      <Canasta
        productos={carrito}
        onEliminar={(id) =>
          setCarrito((prev) => prev.filter((p) => p.id !== id))
        }
        onActualizarCantidad={(id, cantidad) =>
          setCarrito((prev) =>
            prev.map((p) => (p.id === id ? { ...p, cantidad } : p)),
          )
        }
        onLimpiarCanasta={limpiarCarrito}
      />

      <main className="contenido-principal">
        <SelectorCategoria
          onCategoriaChange={(categoria) => {
            filtrarPorCategoria(categoria);
            setProductoActivoId(null);
          }}
        />

        <div className="grupo-buscador">
          <ProductoBuscador
            placeholder="Buscar producto..."
            onBuscar={filtrarPorNombre}
          />
        </div>

        <ProductoGrid
          productos={productosFiltrados}
          productoActivo={productoActivoId}
          onSelect={toggleProductoActivo}
          onAgregarAlCarrito={agregarAlCarrito}
        />

        {mostrarPopup && (
          <div className="popup-agregado">Producto agregado al carrito</div>
        )}
      </main>
    </div>
  );
}
